module.exports = __webpack_public_path__ + "masternodeapp.svg?c44baf8dbb60d6abec14f435432ceb91";